import { Button } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { Fragment, useState } from "react";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  leftButton: {
    marginRight: "auto",
  },
});

const TemplateUploadInvoiceButton = () => {
  const [open, setOpen] = useState<boolean>(false);
  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label="Download Template Invoice"
        onClick={handleOpenDialog}
        className={classes.leftButton}
      />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          Template Import Mass Import Invoice
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            1. You can download template for upload mass invoices to system in
            this link below.
          </Typography>
          <Typography gutterBottom>
            <Link href="https://karen-prod-storage.s3.ap-southeast-1.amazonaws.com/templates/Template+Import+Invoice+Kaye.xlsx">
              Template Import Invoice Kaye.xlsx
            </Link>
          </Typography>
          <br />
          <Typography gutterBottom>
            2. After fill the sheet, export document to CSV format, then upload
            the document.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default TemplateUploadInvoiceButton;
